import * as rcdu from "./RCDataUtil";

/****************************   Used in all modes   *******************************/

function calcHouseholdConversionFactor(indCurrID, indicatorObjList) {

    let value = 0;

    const targPopValue = rcdu.getIndTargPopValue(indCurrID, indicatorObjList);
    const numIntervHHs = rcdu.getIndNumIntervHHs(indCurrID, indicatorObjList);
    const propHHResponseRate = rcdu.getIndPropHHResponseRate(indCurrID, indicatorObjList);

    let x = propHHResponseRate;
    let y = 0;

    if (x > 0) {

        y = numIntervHHs / x;

    }


    if (y > 0) {

        value = targPopValue / y;

    }

    return value;

}

/********************   Precisions --> Households   *******************************/

export function calcReqNumTargIndivPr_HH(indCurrID, indicatorObjList) {

    const estFreq = rcdu.getIndEstFreqPr(indCurrID, indicatorObjList);
    const desPrec = rcdu.getIndDesiredPrecPr(indCurrID, indicatorObjList);
    const designEffect = rcdu.getIndDesignEffectPr(indCurrID, indicatorObjList);

    let a = Math.pow(desPrec / 100, 2);
    let value = 0;

    if (a > 0) {

        value = designEffect * Math.pow(1.96, 2) * (estFreq / 100) * (1 - (estFreq / 100)) / a;
        // Math.pow(1.96, 2) was 4
    }

    return value;

}

export function calcReqNumHouseholdsPr_HH(indCurrID, indicatorObjList) {

    let value = 0;

    const reqNumTargIndiv = calcReqNumTargIndivPr_HH(indCurrID, indicatorObjList);
    const HHConvFactor = calcHouseholdConversionFactor(indCurrID, indicatorObjList);

    if (HHConvFactor > 0) {

        value = reqNumTargIndiv / HHConvFactor;

    }

    return value;

}

/********************   Precision --> Precision   *******************************/

export function calcReqNumTargIndivPr_Pr(indCurrID, indicatorObjList) {

    let value;

    const desNumHHs = rcdu.getIndDesiredNumHHsPr(indCurrID, indicatorObjList);
    const HHConvFactor = calcHouseholdConversionFactor(indCurrID, indicatorObjList);

    value = desNumHHs * HHConvFactor;

    return value;
}

export function calcRelatedPrecPr_Pr(indCurrID, indicatorObjList) {

    let value = 0;

    const designEffect = rcdu.getIndDesignEffectPr(indCurrID, indicatorObjList);
    const estFreq = rcdu.getIndEstFreqPr(indCurrID, indicatorObjList);
    const reqNumTargIndiv = calcReqNumTargIndivPr_Pr(indCurrID, indicatorObjList);

    if (reqNumTargIndiv > 0) {

        value =
            Math.pow(((designEffect * Math.pow(1.96, 2) * (estFreq / 100) * (1 - (estFreq / 100))) /
            reqNumTargIndiv), (1/2)) * 100;
        // Math.pow(1.96, 2) was 4
    }

    return value;
}

/********************   Power change --> Households   *******************************/

export function calcEstFreqDiffPC_HH(indCurrID, indicatorObjList) {

    let value;

    const estBaseFreq = rcdu.getEstFreqBaselinePC(indCurrID, indicatorObjList);
    const estEndFreq = rcdu.getEstFreqEndlinePC(indCurrID, indicatorObjList);

    value = estEndFreq - estBaseFreq;

    return value;
}

export function calcReqNumTargPopPerSurveyPC_HH(indCurrID, indicatorObjList) {

    let value = 0;

    const designEffect = rcdu.getIndDesignEffectPC(indCurrID, indicatorObjList);
    const x = 7.84;
    const estBaseFreq = rcdu.getEstFreqBaselinePC(indCurrID, indicatorObjList);
    const estEndFreq = rcdu.getEstFreqEndlinePC(indCurrID, indicatorObjList);
    const estFreqDiff = calcEstFreqDiffPC_HH(indCurrID, indicatorObjList);

    if (estFreqDiff > 0) {

        // value = designEffect * x *
        //     ((((estBaseFreq / 100)) * (1 - (estBaseFreq / 100))) +
        //         (((estEndFreq / 100)) * (1 - (estEndFreq / 100)))) /
        //     Math.pow(estFreqDiff / 100, 2);
        value = designEffect * x *
            (1/2) * ((estBaseFreq / 100) + (estEndFreq / 100)) *
            (2 - (estBaseFreq / 100) - (estEndFreq / 100)) /
            Math.pow(estFreqDiff / 100, 2);

    }

    return value;
}

export function calcReqNumHHsPerSurveyPC_HH(indCurrID, indicatorObjList) {

    let value = 0;

    const HHConvFactor = calcHouseholdConversionFactor(indCurrID, indicatorObjList);

    if (HHConvFactor > 0) {

        value =
            calcReqNumTargPopPerSurveyPC_HH(indCurrID, indicatorObjList) /
            calcHouseholdConversionFactor(indCurrID, indicatorObjList);

    }

    return value;

}

/********************   Power change --> Difference   *******************************/

export function calcReqNumIndivPerArmPC_Df(indCurrID, indicatorObjList) {

    let value;

    const desNumHHsPerSurvey = rcdu.getDesNumHHsPerSurveyPC(indCurrID, indicatorObjList);
    const HHConvFactor = calcHouseholdConversionFactor(indCurrID, indicatorObjList);

    value = desNumHHsPerSurvey * HHConvFactor;

    return value;
}

export function calcDetectDiffArmsPC_Df(indCurrID, indicatorObjList) {

    let value = 0;

    const designEffect = rcdu.getIndDesignEffectPC(indCurrID, indicatorObjList);
    const estFreqArm1 = rcdu.getEstFreqBaselinePC(indCurrID, indicatorObjList);
    const estFreqArm2 = rcdu.getEstFreqEndlinePC(indCurrID, indicatorObjList);
    const reqNumIndivPerArm = calcReqNumIndivPerArmPC_Df(indCurrID, indicatorObjList);
    const x = 7.84;

    if (reqNumIndivPerArm > 0) {

        // value =
        //     Math.pow(((designEffect * x *
        //         (((estFreqArm1 / 100) * (1 - (estFreqArm1 / 100))) +
        //             ((estFreqArm2 / 100) * (1 - (estFreqArm2 / 100))))) /
        //         reqNumIndivPerArm), (1/2)) * 100;

        value =
            Math.pow(((designEffect * x *
            (1/2) * ((estFreqArm1 / 100) + (estFreqArm2 / 100)) *
            (2 - (estFreqArm1 / 100) - (estFreqArm2 / 100))) /
            reqNumIndivPerArm), (1/2)) * 100;

    }

    return value;
}

